import * as tslib_1 from "tslib";
import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../../../_constants/validation-format-constants';
import { UserNameDisplayResultDto } from '../../../../../_models/user-name-display-result-dto';
import { APAdjustmentAttachmentRawDto } from './ap-adjustment-attachement-raw-dto';
import { APAdjustmentItemRawDto } from './ap-adjustment-item-raw-dto';
const ɵ0 = () => Date, ɵ1 = () => Date, ɵ2 = () => APAdjustmentItemRawDto, ɵ3 = () => APAdjustmentAttachmentRawDto, ɵ4 = () => UserNameDisplayResultDto;
export class APAdjustmentRawDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    Transform(dateJSONTransformer, { toPlainOnly: true }),
    tslib_1.__metadata("design:type", Date)
], APAdjustmentRawDto.prototype, "docDate", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    Transform(dateJSONTransformer, { toPlainOnly: true }),
    tslib_1.__metadata("design:type", Date)
], APAdjustmentRawDto.prototype, "postDate", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Array)
], APAdjustmentRawDto.prototype, "items", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Array)
], APAdjustmentRawDto.prototype, "attachments", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], APAdjustmentRawDto.prototype, "updatedByUser", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
